import Image from "next/image";

export function ContributeToGroupVideo() {
  return (
    <div className="grid h-112 w-full grid-cols-1 grid-rows-5 items-center overflow-hidden rounded-2xl border border-gray-200 shadow-xl md:h-64 md:grid-cols-3 md:grid-rows-1">
      <div className="relative col-span-1 row-span-2 h-full overflow-hidden bg-yellow-300">
        <Image
          src="/images/create-group-video/group-video-contributor-prompt.svg"
          priority={true}
          alt="Group video contributor prompt"
          width="344"
          height="175"
          className="h-full w-full object-contain"
        />
      </div>
      <section className="col-span-1 row-span-3 space-y-4 px-8 md:col-span-2 md:row-span-1">
        <h2 className="font-sans text-lg font-semibold">
          Contribute to a Group Video
        </h2>
        <div className="col-span-1 inline-grid gap-4">
          <div className="flex items-center space-x-2">
            <div className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gray-300">
              <div className="text-xs">1</div>
            </div>
            <div className="text-sm md:text-base">
              {"Tap the link shared by the organizer."}
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <div className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gray-300">
              <div className="text-xs">2</div>
            </div>
            <div className="text-sm md:text-base">
              {"You'll be directed to the Record & Upload page."}
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <div className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gray-300">
              <div className="text-xs">3</div>
            </div>
            <div className="text-sm md:text-base">
              {"Record and submit your video. That's it!"}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
